import * as restApi from "./restApi";
import { assertId, assertNumber } from "./restApi";

const collectionUrl = "api/user";
const enc = encodeURIComponent;

export const existsRecord = restApi.existsRecord.bind(null, {}, collectionUrl);
export const existRecords = restApi.existRecords.bind(null, {}, collectionUrl);

export const fetchRecord = restApi.fetchRecord.bind(null, {}, collectionUrl);
export const fetchRecords = restApi.fetchRecords.bind(null, {}, collectionUrl);
export const updateRecord = restApi.updateRecord.bind(null, {}, collectionUrl);
export const insertRecord = restApi.insertRecord.bind(null, {}, collectionUrl);

export const addUserDivision = function (userId, divisionId) {
  assertId(divisionId) && assertId(divisionId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(userId)}/divisions`, divisionId, {});
};

export const removeUserDivision = function (userId, divisionId) {
  assertId(divisionId) && assertId(divisionId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(userId)}/divisions`, divisionId);
};

export const addUserRole = function (userId, roleId) {
  assertNumber(userId) && assertId(roleId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(userId)}/roles`, roleId, {});
};

export const removeUserRole = function (userId, roleId) {
  assertNumber(userId) && assertId(roleId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(userId)}/roles`, roleId);
};
